import { hsl as d3hsl } from "d3-color";


export const lightColor = _color => {
    let __color = d3hsl(_color);
    let _lightColor = __color;
    _lightColor.s = 0.4;
    _lightColor.l = 0.8;
    return _lightColor;
  }